import PropTypes from 'prop-types';

const { string, node } = PropTypes;

export const sso = PropTypes.shape({
  login: PropTypes.shape({
    href: PropTypes.string.isRequired
  }).isRequired
});

export const link = PropTypes.shape({
  href: string,
  title: string
});

export const eids = PropTypes.shape({
  click: string,
  impression: string
});

export const messages = PropTypes.shape({
  noNotificationsTitle: node.isRequired,
  noNotificationsText: node.isRequired,
  headerText: node.isRequired,
  failedNotificationsTitle: node.isRequired,
  failedNotificationsText: node.isRequired,
  failedNotificationsLink: node.isRequired
});

export const notification = PropTypes.shape({
  title: string.isRequired,
  text: string.isRequired,
  severity: string.isRequired,
  eids: eids,
  _links: PropTypes.shape({
    resolve: link
  }).isRequired
});

const shapes = {
  sso,
  link,
  eids,
  messages,
  notification
};

export { shapes as default };

